import { Assistant } from '../../../../services/assistants/Assistants.types';
import './Assistantlistcard.css';

export const contentfulPortraitUrl = (url?: string, size = 480) => {
  if (!url || !url.includes('images.ctfassets.net')) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}w=${size}&q=85&fm=webp`;
};

export const formatCharge = (charge: string) => {
  const trimmed = charge.trim();
  if (!trimmed) return trimmed;
  const lower = trimmed.toLocaleLowerCase('es');
  return lower.charAt(0).toLocaleUpperCase('es') + lower.slice(1);
};

type AssistantListCardProps = {
  assistant: Assistant;
  onSelect: (assistant: Assistant) => void;
};

const AssistantListCard = ({ assistant, onSelect }: AssistantListCardProps) => {
  const { name, charge, program, photo } = assistant;
  const portraitUrl = contentfulPortraitUrl(photo?.url);
  return (
    <article className="assistant-card lis-card">
      <button type="button" className="assistant-card-trigger" onClick={() => onSelect(assistant)} aria-haspopup="dialog" aria-label={`Ver información ampliada de ${name}`}>
        {portraitUrl ? (
          <span className="assistant-media">
            <img src={portraitUrl} alt={`Fotografía de ${name}`} className="assistant-photo" loading="lazy" decoding="async" />
          </span>
        ) : (
          <span className="assistant-media assistant-photo--fallback" aria-hidden="true">{name.trim().charAt(0)}</span>
        )}
        <span className="assistant-card-copy">
          <span className="assistant-card-name">{name}</span>
          <span className="assistant-charge">{formatCharge(charge)}</span>
          <span className="assistant-program">{program}</span>
        </span>
      </button>
    </article>
  );
};

export default AssistantListCard;
